import Announcements from '@admin/components/announcements'
import Notifications from './notifications'
import Search from './search'

const badges = [
  { 
    title: 't(Help)',
    weight: 10,
    access: { team: { provider: { id: { $eq: 2 } } } },
    help: true,
    route: '/admin/help',
    svg: 'circle_help'
  },
  { 
    title: 't(Announcements)',
    weight: 10,
    svg: 'megaphone',
    access: { 'features.announcements': { $eq: true } },
    drawer: {
      component: Announcements,
      width: 500
    },
    count: (props, context) => ({
      endpoint: '/api/admin/announcements/unread',
      refresh: [
        `/accounts/${context.admin.account.id}/admin/announcements/unread`,
        `/providers/${context.provider.id}/admin/announcements/unread`
      ]
    })
  },
  { 
    title: 't(Notifications)', 
    weight: 7, 
    svg: 'bell', 
    sidebar: Notifications, 
    route: '/admin/notifications',
    count: (props, context) => ({
      endpoint: '/api/admin/notifications/unread', 
      refresh: `/accounts/${context.admin.account.id}/admin/notifications/unread`
    })
  },
  { 
    title: 't(Search)', 
    weight: 6, 
    svg: 'search', 
    sidebar: Search, 
    route: '/admin/search'
  }
]

export default badges
